import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Popup } from 'camino-react'

import TimesheetForm from 'Components/Timesheets/TimesheetForm'

const AllTimesheetsModal = ({
  trigger,
  onClose,
  modalOpen,
  timesheets
}) => (
  <Popup
    modal
    trigger={trigger}
    open={modalOpen}
    onClose={onClose}
    contentStyle={{
      zIndex: '99',
      borderRadius: '10px',
      maxHeight: '95%',
      overflowY: 'scroll',
      color: '#666'
    }}
  >
    {_.map(timesheets, timesheet => (
        <>
          <h3
            style={{ textAlign: 'center', marginBottom: '0' }}
          >
            {_.truncate(timesheet.description, {
              'length': 40,
              'separator': /,? +/
            })}
          </h3>
          <TimesheetForm
            key={timesheet.id}
            allTimesheetsView
            {...timesheet}
          />
        </>
    ))}
  </Popup>
)

export default AllTimesheetsModal;
